/**
 * Wrapper для инициализации Select2
 * @return {jQuery}
 */

(function($){
    'use strict';

    $.fn.selectWrapper = function () {
        const $select = $(this);
        /**
         * Инициализация
         * @return {void}
         */
        const init = function () {
            $select.data('select2', $select.select2({
                width: 'style',
                dropdownParent: $select.parent(),
                dropdownCssClass: $select.data('select2-class'),
                containerCssClass: $select.data('select2-class')
            }));

            if (typeof PerfectScrollbar !== 'undefined') {
                $select.on('select2:open', function () {
                    $('.select2-results__options').each(function (index, el) {
                        if (typeof $(el).data('ps') === 'undefined') {
                            $(el).data('ps', new PerfectScrollbar(el, {
                                suppressScrollX: true
                            }));
                        }
                        setTimeout(function () {
                            $(el).data('ps').update();
                        }, 100);
                    });
                });
            }
        }

        init();

        return this;
    }

})(jQuery);
